import { JobListPage } from "@/features/job/components/JobList";

const JobList = () => {
  return <JobListPage />;
};

export default JobList;
